module.exports = __webpack_public_path__ + "75a9b8cddcd9418eb51ceeb4f3c7708f.otf";